import { InfoBox } from '@skytech/ui'
import { sanitizeAndInsertTargetBlank } from '@skytech/utils/html-sanitization'
import { useQuery } from '@tanstack/react-query'
import { twJoin } from 'tailwind-merge'

import queries from '@/api/queries'
import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import Page from '@/components/page/Page'
import useSetup from '@/hooks/setup'
import useUser from '@/hooks/user'
import { ecomPolicyResources } from '@/resources/ecom-policy'

export const Guidelines = () => {
  const user = useUser()
  const setup = useSetup()
  const { whiteLabel } = useAppContext()

  const { data: ecomPolicyData } = useQuery(queries.policyList(), ecomPolicyResources.getList)

  const sda_comment = setup?.sda_comment

  const device_policy_message =
    user && setup && user.devicePolicyId ? setup.device_policy_message : null

  return (
    <Page pageWrapperClassName="max-w-5xl pb-8 sm:pb-16">
      <h2 className="!m-1 text-xl sm:!m-4 sm:text-2xl">
        <Translation id="My guidelines" />
      </h2>

      <div>
        {(sda_comment || device_policy_message) && (
          <h4 className="mx-0 my-1.5 !font-bold">TelePolicy</h4>
        )}

        {sda_comment && (
          <div className="my-4">
            {sda_comment
              .trim()
              .split(/\n\s*\n/)
              .map((item: string, i: number) => (
                <p key={i} className={twJoin(whiteLabel, '!mx-0 !mb-4 !ml-4 !mt-1')}>
                  {item.split('\n').map((item, i) => (
                    <span
                      className="block min-h-4"
                      key={i}
                      dangerouslySetInnerHTML={{ __html: sanitizeAndInsertTargetBlank(item) }}
                    />
                  ))}
                </p>
              ))}
          </div>
        )}

        {device_policy_message && (
          <div className="my-4">
            <h4 className="mb-4 font-bold sm:mt-8">
              <Translation id="DEVICE POLICY" className="!font-bold" />
            </h4>

            {device_policy_message.split(/\n\s*\n/).map((item: string, i: number) => (
              <p key={i} className="!mx-0 !mb-4 !mt-1">
                {item
                  .trim()
                  .split('\n')
                  .map((item: string, i: number) => (
                    <span
                      className="block min-h-4"
                      dangerouslySetInnerHTML={{ __html: sanitizeAndInsertTargetBlank(item) }}
                      key={i}
                    />
                  ))}
              </p>
            ))}
          </div>
        )}

        {!device_policy_message && !sda_comment && (
          <InfoBox emphasis="warning" marginTop={4}>
            <Translation id="Tjenester ikke aktivert." />
          </InfoBox>
        )}

        {ecomPolicyData?.policyList && ecomPolicyData?.policyList.length > 0 && (
          <div className="my-4 whitespace-pre-wrap sm:mt-8">
            {ecomPolicyData?.policyList
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(policy => {
                if (!policy.messageToEmployee) return null

                return (
                  <div key={policy.id} className="mb-4">
                    <h4 className="mx-0 my-1.5 !font-bold">{policy.name}</h4>

                    {policy.messageToEmployee
                      .trim()
                      .split(/\n\s*\n/)
                      .map((item: string, i: number) => (
                        <p key={i} className="!mx-0 !mb-4 !ml-4 !mt-1">
                          {item.split('\n').map((item: string, i: number) => (
                            <span
                              key={i}
                              className="block min-h-4"
                              dangerouslySetInnerHTML={{
                                __html: sanitizeAndInsertTargetBlank(item),
                              }}
                            />
                          ))}
                        </p>
                      ))}
                  </div>
                )
              })}
          </div>
        )}
      </div>
    </Page>
  )
}
